<h2 mat-dialog-title>Sorok összekapcsolása</h2>
<mat-dialog-content>
   <div style="display: flex; align-items: center; gap: 16px">
      <mat-form-field style="max-width: 100px">
         <input matInput [(ngModel)]="source" type="number" min="0" [disabled]="sourceDisabled" />
         <mat-label>Forrás</mat-label>
      </mat-form-field>
      <div style="font-size: 32px">→</div>
      <mat-form-field style="max-width: 100px">
         <input matInput [(ngModel)]="target" type="number" min="0" [disabled]="targetDisabled" />
         <mat-label>Cél</mat-label>
      </mat-form-field>
      <button mat-button (click)="swapSourceAndTarget()">
         <mat-icon>swap_horiz</mat-icon>
      </button>
   </div>

   <table mat-table [dataSource]="dataSource" [width]="'100%'">
      <ng-container matColumnDef="id">
         <th mat-header-cell *matHeaderCellDef class="text-center p0">Sorszám</th>
         <td mat-cell *matCellDef="let element" class="text-center p0">
            {{ element.id }}
         </td>
      </ng-container>

      <ng-container matColumnDef="name">
         <th mat-header-cell *matHeaderCellDef class="text-left">Diák neve</th>
         <td mat-cell *matCellDef="let element" class="text-left">
            {{ element.name }}
         </td>
      </ng-container>

      <ng-container matColumnDef="birthDate" class="text-left">
         <th mat-header-cell *matHeaderCellDef class="text-left">Születési dátum</th>
         <td mat-cell *matCellDef="let element">
            {{ element.birthDate | formatDateIso }}
         </td>
      </ng-container>

      <ng-container matColumnDef="studentStatus" class="text-left">
         <th mat-header-cell *matHeaderCellDef class="text-left">Diák státusz</th>
         <td mat-cell *matCellDef="let element">
            {{ getStatus(element.studentStatus) | translate }}
         </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="headerRow"></tr>
      <tr
         mat-row
         *matRowDef="let row; columns: headerRow"
         style="cursor: pointer"
         (click)="onRowClicked(row.id)"
      ></tr>
   </table>
</mat-dialog-content>
<mat-dialog-actions align="end" style="margin-top: 24px">
   <button mat-button (click)="dialogRef.close()">Mégse</button>

   <button
      mat-flat-button
      color="secondary"
      (click)="onJoinClicked()"
      [disabled]="!source || source <= 0"
   >
      Összerendelés
   </button>
</mat-dialog-actions>
